import React from "react";
import LogUtil from "./util/LogUtil";
import AppState from "./model/AppState";
import Rodape from "./components/Rodape";
import NavegadorUtil from "./util/NavegadorUtil";
import { ReactComponent as ImagemMenuBack } from "./assets/images/icons/menu-back.svg";
import { ReactComponent as ImagemMeusDados } from "./assets/images/icons/menu/user.svg";
import { ReactComponent as ImagemMeusPedidos } from "./assets/images/icons/menu/shopping-bag.svg";
import { ReactComponent as ImagemInspirese } from "./assets/images/icons/menu/inspirese.svg";
import { ReactComponent as ImagemLojas } from "./assets/images/icons/menu/lojas.svg";
import { ReactComponent as ImagemAjuda } from "./assets/images/icons/menu/help-circle.svg";
import { withRouter, RouteComponentProps, Link } from "react-router-dom";
import Carregando from "./components/Carregando";

interface IMenuLogadoProps extends RouteComponentProps {}

interface IMenuLogadoState {}

class MenuLogado extends React.Component<IMenuLogadoProps, IMenuLogadoState> {
  constructor(props: IMenuLogadoProps) {
    super(props);
    this.logout = this.logout.bind(this);
  }

  componentDidMount(): void {
    LogUtil.logPage("Menu - logado");

    if (AppState.getUsuarioLogado() === null) {
      NavegadorUtil.redirect("/menu", this.props.history);
    }
  }

  logout(): void {
    AppState.setUsuarioLogado(null);
    AppState.setMaioridade(false);
    NavegadorUtil.alerta(this, "Usuário deslogado com sucesso!");
    if (this && this.props && this.props.history) {
      NavegadorUtil.redirect("/menu", this.props.history);
    }
  }

  render(): any {
    return (
      <section className="menu">
        <div className="header">
          <div className="back" onClick={() => this.props.history.goBack()}>
            <ImagemMenuBack />
          </div>
        </div>
        <ul>
          <li>
            <Link to={NavegadorUtil.getUrl("/cadastre-se")}>
              <ImagemMeusDados /> Minha conta
            </Link>
            <span>Edite os dados de sua conta</span>
          </li>
          <li>
            <Link to={NavegadorUtil.getUrl("/pedidos")}>
              <ImagemMeusPedidos /> Meus pedidos
            </Link>
            <span>Seu histórico de pedidos</span>
          </li>
          <li>
            <Link to={NavegadorUtil.getUrl("/inspirese")}>
              <ImagemInspirese /> Inspire-se
            </Link>
            <span>Dicas, receitas e listas especiais!</span>
          </li>
          <li>
            <Link to={NavegadorUtil.getUrl("/lojas")}>
              <ImagemLojas /> Lojas
            </Link>
            <span>Encontre o Oba mais perto de você.</span>
          </li>
          <li>
            <Link to={NavegadorUtil.getUrl("/ajuda")}>
              <ImagemAjuda /> Ajuda
            </Link>
          </li>
          <li>
            <p onClick={this.logout} className="thin">
              Sair
            </p>
          </li>
        </ul>
        <Rodape parent={this} ativo="Menu"></Rodape>
        <Carregando exibir={false} concluido={true}></Carregando>
      </section>
    );
  }
}

export default withRouter(MenuLogado);
